import NodeHandlerBase from "../node-handler-base";
import inputFieldStore from "./input-field-store";

export default class InputFieldHandler extends NodeHandlerBase {
  constructor(ctx) {
    super(ctx, 'inputField');
    this.store.registerModule('inputFieldStore', inputFieldStore);
  }

  async handleNode(node, options = {}) {
    const result = new Promise((resolve) => {
      const unwatch = this.store.watch(
        (localstate) => localstate.inputFieldStore.submittedValue,
        (newValue) => {
          if (node.storage) {
            this.store.dispatch('chatbotStore/addToStorage', { key: node.storage, data: newValue });
          }
          unwatch();
          resolve(this.store.getters['chatbotStore/nextNode'](`${node.id}`));
        }
      )
    });

    await super.handleNode(node, { ...options, handleStorage: false });
    return result;
  }
}